(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-tax-free-eligibility-types"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionSelectors = document.querySelectorAll('.pl-tax-free-eligibility-types');

    sectionSelectors.forEach(function (section) {
      var links = section.querySelectorAll('.pl-tax-free-eligibility-types__item-link[data-scroll-target]');

      links.forEach(function (link) {
        link.addEventListener('click', function () {
          var targetId = link.getAttribute('data-scroll-target');
          if (!targetId) return;

          var target = document.querySelector(targetId) || document.getElementById(targetId.replace('#', ''));
          if (!target) return;

          var offset = 80;
          var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth',
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-ai-assist"] && !Shopify.designMode) return;
  try {
    
  class SpxAiAssistForm extends HTMLElement {
    static MAX_URL_LENGTH = 2000;

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.input = this.querySelector('[data-spx-ai-assist-input]');
      this.placeholderEl = this.querySelector('[data-spx-ai-assist-placeholder]');
      this.submitEl = this.querySelector('[data-spx-ai-assist-submit]');
      this.errorEl = this.querySelector('[data-spx-ai-assist-error]');
      this.placeholderText = this.dataset.placeholder || '';
      this.baseUrl = (this.dataset.url || '').trim();
      this.typingIndex = 0;
      this.deleting = false;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onInput = this.onInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.input?.addEventListener('input', this.onInput);
      this.input?.addEventListener('keydown', this.onKeydown);
      this.submitEl?.addEventListener('click', this.onSubmit);

      this.syncPlaceholderVisibility();
      this.autoGrow();
      this.startTypewriter();
    }

    disconnectedCallback() {
      this.stopTypewriter();
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('keydown', this.onKeydown);
      this.submitEl?.removeEventListener('click', this.onSubmit);
      this.dataset.initialized = 'false';
    }

    hasValue() {
      return Boolean(this.input?.value.trim());
    }

    syncPlaceholderVisibility() {
      if (!this.placeholderEl) return;
      this.placeholderEl.classList.toggle('is-hidden', this.hasValue());
    }

    autoGrow() {
      if (!this.input) return;
      this.input.style.height = 'auto';
      this.input.style.height = `${this.input.scrollHeight}px`;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.classList.remove('is-visible');
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.classList.add('is-visible');
    }

    onInput() {
      this.clearError();
      this.syncPlaceholderVisibility();
      this.autoGrow();
      if (this.hasValue()) {
        this.stopTypewriter();
        if (this.placeholderEl) this.placeholderEl.textContent = '';
      } else {
        this.startTypewriter();
      }
    }

    onKeydown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.onSubmit();
      }
    }

    buildTargetUrl(query) {
      const withEncodedQ = (baseHref, value) => {
        const joiner = baseHref.includes('?') ? '&' : '?';
        return `${baseHref}${joiner}q=${encodeURIComponent(value)}`;
      };

      try {
        const url = new URL(this.baseUrl, window.location.origin);
        url.searchParams.delete('q');
        const baseHref = url.toString();

        let low = 0;
        let high = query.length;
        let safeQuery = '';

        while (low <= high) {
          const mid = (low + high) >> 1;
          const candidate = query.slice(0, mid);
          if (withEncodedQ(baseHref, candidate).length <= SpxAiAssistForm.MAX_URL_LENGTH) {
            safeQuery = candidate;
            low = mid + 1;
          } else {
            high = mid - 1;
          }
        }

        if (!safeQuery) return null;

        return {
          href: withEncodedQ(baseHref, safeQuery),
          truncated: safeQuery.length < query.length,
        };
      } catch (error) {
        const joiner = this.baseUrl.includes('?') ? '&' : '?';
        const prefix = `${this.baseUrl}${joiner}q=`;
        const budget = SpxAiAssistForm.MAX_URL_LENGTH - prefix.length;
        if (budget <= 0) return null;

        let encoded = encodeURIComponent(query);
        let truncated = false;
        if (encoded.length > budget) {
          truncated = true;
          let end = query.length;
          while (end > 0 && encodeURIComponent(query.slice(0, end)).length > budget) {
            end -= 1;
          }
          if (end <= 0) return null;
          encoded = encodeURIComponent(query.slice(0, end));
        }

        return {
          href: `${prefix}${encoded}`,
          truncated,
        };
      }
    }

    onSubmit(event) {
      event?.preventDefault?.();
      this.clearError();

      const query = this.input?.value.trim() || '';
      if (!query || !this.baseUrl) return;

      const result = this.buildTargetUrl(query);
      if (!result) {
        this.showError('Your question is too long to open. Please shorten it and try again.');
        return;
      }

      if (result.truncated) {
        this.showError('Your question is too long for the link. Please shorten it and try again.');
        return;
      }

      window.open(result.href, '_blank', 'noopener,noreferrer');
    }

    startTypewriter() {
      if (!this.placeholderEl || this.hasValue()) return;
      this.stopTypewriter();

      if (this.reducedMotion || !this.placeholderText) {
        this.placeholderEl.textContent = this.placeholderText;
        return;
      }

      this.typingIndex = 0;
      this.deleting = false;
      this.placeholderEl.textContent = '';
      this.tickTypewriter();
    }

    stopTypewriter() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    tickTypewriter() {
      if (!this.placeholderEl || this.hasValue()) return;

      const full = this.placeholderText;
      if (!full) return;

      if (!this.deleting) {
        this.typingIndex += 1;
        this.placeholderEl.textContent = full.slice(0, this.typingIndex);
        if (this.typingIndex >= full.length) {
          this.deleting = true;
          this.timer = window.setTimeout(() => this.tickTypewriter(), 1600);
          return;
        }
        this.timer = window.setTimeout(() => this.tickTypewriter(), 70);
        return;
      }

      this.typingIndex -= 1;
      this.placeholderEl.textContent = full.slice(0, Math.max(this.typingIndex, 0));
      if (this.typingIndex <= 0) {
        this.deleting = false;
        this.timer = window.setTimeout(() => this.tickTypewriter(), 400);
        return;
      }
      this.timer = window.setTimeout(() => this.tickTypewriter(), 40);
    }
  }

  if (!customElements.get('spx-ai-assist-form')) {
    customElements.define('spx-ai-assist-form', SpxAiAssistForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-collection-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getLayout = () => (window.matchMedia('(min-width: 750px)').matches ? 'desktop' : 'mobile');

    const mountPanel = (panel) => {
      if (!(panel instanceof HTMLElement)) return;
      const layout = getLayout();
      if (panel.dataset.collectionLayout === layout) return;

      const template = panel.querySelector(`template[data-collection-layout="${layout}"]`);
      const host = panel.querySelector('[data-collection-product-host]');
      if (!(template instanceof HTMLTemplateElement) || !(host instanceof HTMLElement)) return;

      host.replaceChildren(template.content.cloneNode(true));
      panel.dataset.collectionLayout = layout;
    };

    const syncActivePanel = (root) => {
      if (!(root instanceof HTMLElement)) return;
      const group = root.querySelector('spx-tab-group');
      if (!(group instanceof HTMLElement)) return;

      const activeTab = group.querySelector('spx-tab[slot="nav"][aria-selected="true"]');
      const activePanel = group.querySelector('spx-panel[data-spx-tab-active]');
      if (!(activePanel instanceof HTMLElement)) return;

      mountPanel(activePanel);

      const link = root.querySelector('[data-collection-link]');
      if (link instanceof HTMLAnchorElement && activeTab instanceof HTMLElement) {
        const url = activeTab.dataset.collectionUrl || '#';
        link.href = url;
        link.hidden = url === '#';
        const label = link.querySelector('[data-collection-link-label]');
        if (label instanceof HTMLElement) label.textContent = activeTab.dataset.collectionLinkLabel || '';
      }
    };

    const init = (root) => {
      if (!(root instanceof HTMLElement) || root.dataset.collectionTabsInitialized === 'true') return;
      root.dataset.collectionTabsInitialized = 'true';

      const group = root.querySelector('spx-tab-group');
      if (!(group instanceof HTMLElement)) return;

      requestAnimationFrame(() => syncActivePanel(root));
      group.addEventListener('click', () => requestAnimationFrame(() => syncActivePanel(root)));
      group.addEventListener('keydown', () => requestAnimationFrame(() => syncActivePanel(root)));
    };

    const initAll = () => document.querySelectorAll('[data-spx-collection-product-tabs]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    if (document.documentElement.dataset.collectionTabsViewportListener !== 'true') {
      document.documentElement.dataset.collectionTabsViewportListener = 'true';
      window.matchMedia('(min-width: 750px)').addEventListener('change', () => {
        document
          .querySelectorAll('[data-spx-collection-product-tabs] spx-panel[data-spx-tab-active]')
          .forEach(mountPanel);
      });
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement)
        event.target.querySelectorAll('[data-spx-collection-product-tabs]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-creator-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGallery = (root) => {
      if (!root) return;

      const variant = window.matchMedia('(min-width: 750px)').matches ? 'desktop' : 'mobile';
      if (root.dataset.cgVariant !== variant) {
        root.querySelectorAll('[data-cg-video] video').forEach((video) => video.pause());

        const template = root.querySelector(`[data-cg-${variant}-template]`);
        const host = root.querySelector('[data-cg-slider-host]');
        if (!template || !host) return;

        host.replaceChildren(template.content.cloneNode(true));
        root.dataset.cgVariant = variant;
      }

      root.querySelectorAll('[data-cg-video]').forEach((wrap) => {
        if (wrap.dataset.cgVideoInit === 'true') return;
        wrap.dataset.cgVideoInit = 'true';
        const video = wrap.querySelector('video');
        const btn = wrap.querySelector('[data-cg-play]');
        if (!video || !btn) return;

        const pauseOthers = () => {
          root.querySelectorAll('[data-cg-video]').forEach((other) => {
            if (other === wrap) return;
            const v = other.querySelector('video');
            if (v && !v.paused) {
              try {
                v.pause();
              } catch (e) {}
            }
            other.removeAttribute('data-playing');
          });
        };

        video.addEventListener('play', () => {
          pauseOthers();
          wrap.setAttribute('data-playing', 'true');
          btn.setAttribute('aria-label', 'Pause video');
        });
        video.addEventListener('pause', () => {
          wrap.removeAttribute('data-playing');
          btn.setAttribute('aria-label', 'Play video');
        });
        btn.addEventListener('click', async () => {
          try {
            if (video.paused) {
              pauseOthers();
              await video.play();
            } else {
              video.pause();
            }
          } catch (e) {}
        });
      });
    };

    const initAll = () => {
      document.querySelectorAll('[data-gallery]').forEach(initGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    if (document.documentElement.dataset.cgViewportListener !== 'true') {
      document.documentElement.dataset.cgViewportListener = 'true';
      window.matchMedia('(min-width: 750px)').addEventListener('change', initAll);
    }

    document.addEventListener('shopify:section:load', (e) => {
      const el = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (el) el.querySelectorAll('[data-gallery]').forEach(initGallery);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-curated-patterns-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-curated-patterns-carousel')) {
    class SpxCuratedPatternsCarousel extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        this._signal = this._abort.signal;
        this.viewport = this.querySelector('[data-viewport]');
        this.tracks = Array.from(this.querySelectorAll('[data-track]'));
        if (!this.viewport || this.tracks.length === 0) return;
        this._onClick = this._onClick.bind(this);
        this._onKeydown = this._onKeydown.bind(this);
        this._onPointerEnter = () => this.viewport.classList.add('is-paused');
        this._onPointerLeave = () => this.viewport.classList.remove('is-paused');
        this._onResize = this._onResize.bind(this);
        this._mqlMobile = window.matchMedia('(max-width: 749px)');
        this._mqlReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._mqlMobile.addEventListener('change', this._onResize, { signal: this._signal });
        this._mqlReduced.addEventListener('change', this._onResize, { signal: this._signal });
        this.viewport.addEventListener('click', this._onClick, { signal: this._signal });
        this.viewport.addEventListener('keydown', this._onKeydown, { signal: this._signal });
        this.viewport.addEventListener('pointerenter', this._onPointerEnter, { signal: this._signal });
        this.viewport.addEventListener('pointerleave', this._onPointerLeave, { signal: this._signal });
        document.addEventListener('click', this._onDocumentClick.bind(this), { signal: this._signal });
        window.addEventListener('resize', this._onResize, { signal: this._signal });
        this._ro = new ResizeObserver(() => this._refresh());
        this._ro.observe(this.viewport);
        this._refresh();
      }

      disconnectedCallback() {
        this._abort.abort();
        if (this._ro) this._ro.disconnect();
        this.tracks.forEach((track) => {
          track.querySelectorAll('[data-clone="true"]').forEach((el) => el.remove());
          track.removeAttribute('data-animated');
          track.style.removeProperty('--spx-curated-duration');
        });
      }

      _onResize() {
        clearTimeout(this._rt);
        this._rt = setTimeout(() => this._refresh(), 120);
      }

      _refresh() {
        const isMobile = this._mqlMobile.matches;
        const prefersReduced = this._mqlReduced.matches;
        const shouldAnimate = !isMobile && !prefersReduced;
        this.tracks.forEach((track) => {
          track.querySelectorAll('[data-clone="true"]').forEach((el) => el.remove());
          const originals = Array.from(track.children).filter((el) => el.getAttribute('data-clone') !== 'true');
          if (originals.length === 0) {
            track.removeAttribute('data-animated');
            return;
          }
          if (!shouldAnimate) {
            track.removeAttribute('data-animated');
            originals.forEach((el) => {
              el.removeAttribute('aria-hidden');
              el.removeAttribute('inert');
              el.removeAttribute('data-clone-hidden');
            });
            return;
          }
          const viewportWidth = this.viewport.clientWidth || window.innerWidth;
          const gap = parseFloat(getComputedStyle(track).gap) || 24;
          let oneSetWidth = 0;
          originals.forEach((el) => {
            oneSetWidth += el.getBoundingClientRect().width + gap;
          });
          oneSetWidth = Math.max(oneSetWidth - gap, 1);
          const needed = Math.max(2, Math.ceil((viewportWidth * 2) / oneSetWidth) + 1);
          for (let copy = 0; copy < needed; copy += 1) {
            originals.forEach((orig) => {
              const clone = orig.cloneNode(true);
              clone.setAttribute('data-clone', 'true');
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('tabindex', '-1');
              clone.removeAttribute('id');
              clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
              clone.querySelectorAll('button').forEach((btn) => btn.setAttribute('tabindex', '-1'));
              clone.classList.remove('is-open');
              track.appendChild(clone);
            });
          }
          track.setAttribute('data-animated', 'true');
        });
      }

      _onClick(event) {
        const card = event.target.closest('[data-card][data-locked="true"]');
        if (!card) return;
        if (card.hasAttribute('data-clone')) return;
        event.preventDefault();
        const isOpen = card.classList.contains('is-open');
        this._closeAll();
        if (!isOpen) card.classList.add('is-open');
      }

      _onKeydown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('[data-card][data-locked="true"]');
        if (!card || card.hasAttribute('data-clone')) return;
        event.preventDefault();
        const isOpen = card.classList.contains('is-open');
        this._closeAll();
        if (!isOpen) card.classList.add('is-open');
      }

      _onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this._closeAll();
          return;
        }
        const insideCard = event.target.closest('[data-card]');
        if (!insideCard) this._closeAll();
      }

      _closeAll() {
        this.querySelectorAll('[data-card].is-open').forEach((el) => el.classList.remove('is-open'));
      }
    }
    customElements.define('spx-curated-patterns-carousel', SpxCuratedPatternsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-custom-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mq = window.matchMedia('(min-width: 768px)');

    const syncHeight = (layout) => {
      const form = layout.querySelector('.spx-custom-form-liquid');
      if (!form || !mq.matches) {
        layout.style.minHeight = '';
        return;
      }
      layout.style.minHeight = `${form.offsetHeight}px`;
    };

    const setup = (scope) => {
      const layouts = (scope || document).querySelectorAll('.spx-custom-form__layout');
      layouts.forEach((layout) => {
        if (layout.dataset.spxFormBound === 'true') {
          syncHeight(layout);
          return;
        }
        layout.dataset.spxFormBound = 'true';
        const form = layout.querySelector('.spx-custom-form-liquid');
        if (!form || typeof ResizeObserver === 'undefined') {
          syncHeight(layout);
          return;
        }
        const observer = new ResizeObserver(() => syncHeight(layout));
        observer.observe(form);
        mq.addEventListener('change', () => syncHeight(layout));
        syncHeight(layout);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup());
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-event-countdown"] && !Shopify.designMode) return;
  try {
    
  class SpxEventCountdown extends HTMLElement {
    static FALLBACK = Date.parse('2088-01-01T00:00:00+00:00');

    connectedCallback() {
      this.endTime = this.parseEndTime(this.dataset.endTime);
      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        mins: this.querySelector('[data-unit="mins"]'),
        secs: this.querySelector('[data-unit="secs"]'),
      };
      this.live = this.querySelector('[data-live]');

      if (this.tick()) return;
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
      this.interval = null;
    }

    parseEndTime(value) {
      const timestamp = Date.parse(value || '');
      return Number.isFinite(timestamp) ? timestamp : SpxEventCountdown.FALLBACK;
    }

    recompute(now = Date.now()) {
      const diff = Math.max(0, this.endTime - now);
      const totalSeconds = Math.floor(diff / 1000);

      return {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor((totalSeconds % 86400) / 3600),
        mins: Math.floor((totalSeconds % 3600) / 60),
        secs: totalSeconds % 60,
        totalSeconds,
      };
    }

    tick() {
      const { days, hours, mins, secs, totalSeconds } = this.recompute();

      if (this.units.days) this.units.days.textContent = String(days);
      if (this.units.hours) this.units.hours.textContent = String(hours).padStart(2, '0');
      if (this.units.mins) this.units.mins.textContent = String(mins).padStart(2, '0');
      if (this.units.secs) this.units.secs.textContent = String(secs).padStart(2, '0');

      if (this.live) {
        this.live.textContent = `${days} days, ${hours} hours, ${mins} minutes, ${secs} seconds remaining`;
      }

      if (totalSeconds <= 0) {
        if (this.live) this.live.textContent = 'Event ended.';
        window.clearInterval(this.interval);
        this.interval = null;
        this.style.display = 'none';
        return true;
      }

      return false;
    }
  }

  if (!customElements.get('spx-event-countdown')) {
    customElements.define('spx-event-countdown', SpxEventCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-find-designer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP = 72;

    const syncControlsVisibility = (root) => {
      const track = root.querySelector('[data-portfolio-track]');
      const prev = root.querySelector('[data-portfolio-prev]');
      const next = root.querySelector('[data-portfolio-next]');
      if (!(track instanceof HTMLElement)) return;

      // 隐藏断点 / 未完成布局时 clientWidth 为 0，不要误藏按钮
      if (track.clientWidth <= 0) {
        prev?.classList.remove('is-hidden');
        next?.classList.remove('is-hidden');
        return;
      }

      const canScroll = track.scrollWidth - track.clientWidth > 4;
      prev?.classList.toggle('is-hidden', !canScroll);
      next?.classList.toggle('is-hidden', !canScroll);
    };

    const bindPortfolio = (root) => {
      if (!(root instanceof HTMLElement) || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      const track = root.querySelector('[data-portfolio-track]');
      const prev = root.querySelector('[data-portfolio-prev]');
      const next = root.querySelector('[data-portfolio-next]');
      if (!(track instanceof HTMLElement)) return;

      // 默认先显示，等布局测完再决定是否隐藏
      prev?.classList.remove('is-hidden');
      next?.classList.remove('is-hidden');

      const onNavClick = (event, direction) => {
        event.preventDefault();
        event.stopPropagation();
        track.scrollBy({ left: direction * STEP, behavior: 'smooth' });
      };

      prev?.addEventListener('click', (event) => onNavClick(event, -1));
      next?.addEventListener('click', (event) => onNavClick(event, 1));

      const runSync = () => syncControlsVisibility(root);

      track.addEventListener('scroll', runSync, { passive: true });
      window.addEventListener('resize', runSync);

      track.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', runSync, { once: true });
      });

      if (typeof ResizeObserver === 'function') {
        const ro = new ResizeObserver(runSync);
        ro.observe(track);
        root._portfolioResizeObserver = ro;
      }

      // 多次补测：图片/轮播显隐后宽度才会正确
      requestAnimationFrame(runSync);
      window.setTimeout(runSync, 100);
      window.setTimeout(runSync, 400);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll?.('[data-designer-portfolio]')?.forEach(bindPortfolio);
      // 断点切换后重新测量可见卡片
      scope.querySelectorAll?.('[data-designer-portfolio]')?.forEach(syncControlsVisibility);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    window.addEventListener('load', () => initAll());

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-flash-deals"] && !Shopify.designMode) return;
  try {
    
  class SpxFlashDealsCountdown extends HTMLElement {
    static FALLBACK = Date.parse('2088-01-01T00:00:00+00:00');

    connectedCallback() {
      this.endTime = this.parseEndTime(this.dataset.endTime);
      this.units = {
        hours: this.querySelector('[data-flash-unit="hours"]'),
        mins: this.querySelector('[data-flash-unit="mins"]'),
        secs: this.querySelector('[data-flash-unit="secs"]'),
      };
      this.live = this.querySelector('[data-flash-live]');
      this.scope = this.closest('.spx-flash-deals');

      if (this.tick()) return;
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
      this.interval = null;
    }

    parseEndTime(value) {
      const timestamp = Date.parse(value || '');
      return Number.isFinite(timestamp) ? timestamp : SpxFlashDealsCountdown.FALLBACK;
    }

    recompute(now = Date.now()) {
      const diff = Math.max(0, this.endTime - now);
      const totalSeconds = Math.floor(diff / 1000);

      return {
        hours: Math.floor(totalSeconds / 3600),
        mins: Math.floor((totalSeconds % 3600) / 60),
        secs: totalSeconds % 60,
        totalSeconds,
      };
    }

    tick() {
      const { hours, mins, secs, totalSeconds } = this.recompute();
      const hoursText = hours > 99 ? '99+' : String(hours).padStart(2, '0');

      if (this.units.hours) this.units.hours.textContent = hoursText;
      if (this.units.mins) this.units.mins.textContent = String(mins).padStart(2, '0');
      if (this.units.secs) this.units.secs.textContent = String(secs).padStart(2, '0');

      if (this.live) {
        this.live.textContent = `${hours} hours, ${mins} minutes, ${secs} seconds remaining`;
      }

      if (totalSeconds <= 0) {
        this.disableBuyButtons();
        if (this.live) this.live.textContent = 'This flash deal has ended.';
        window.clearInterval(this.interval);
        this.interval = null;
        return true;
      }

      return false;
    }

    disableBuyButtons() {
      if (!this.scope) return;

      this.scope.querySelectorAll('.spx-flash-deal-card__btn').forEach((btn) => {
        btn.setAttribute('disabled', '');
        btn.setAttribute('aria-disabled', 'true');
      });
    }
  }

  if (!customElements.get('spx-flash-deals-countdown')) {
    customElements.define('spx-flash-deals-countdown', SpxFlashDealsCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-insitich-ai"] && !Shopify.designMode) return;
  try {
    
  class SpxAiAssistForm extends HTMLElement {
    static MAX_URL_LENGTH = 2000;

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.input = this.querySelector('[data-spx-ai-assist-input]');
      this.placeholderEl = this.querySelector('[data-spx-ai-assist-placeholder]');
      this.submitEl = this.querySelector('[data-spx-ai-assist-submit]');
      this.errorEl = this.querySelector('[data-spx-ai-assist-error]');
      this.placeholderText = this.dataset.placeholder || '';
      this.baseUrl = (this.dataset.url || '').trim();
      this.typingIndex = 0;
      this.deleting = false;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.onInput = this.onInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onQuickTip = this.onQuickTip.bind(this);

      this.input?.addEventListener('input', this.onInput);
      this.input?.addEventListener('keydown', this.onKeydown);
      this.submitEl?.addEventListener('click', this.onSubmit);
      this.querySelectorAll('[data-spx-ai-assist-quick-tip]').forEach((btn) => {
        btn.addEventListener('click', this.onQuickTip);
      });

      this.syncPlaceholderVisibility();
      this.autoGrow();
      this.startTypewriter();
    }

    disconnectedCallback() {
      this.stopTypewriter();
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('keydown', this.onKeydown);
      this.submitEl?.removeEventListener('click', this.onSubmit);
      this.querySelectorAll('[data-spx-ai-assist-quick-tip]').forEach((btn) => {
        btn.removeEventListener('click', this.onQuickTip);
      });
      this.dataset.initialized = 'false';
    }

    hasValue() {
      return Boolean(this.input?.value.trim());
    }

    syncPlaceholderVisibility() {
      if (!this.placeholderEl) return;
      this.placeholderEl.classList.toggle('is-hidden', this.hasValue());
    }

    autoGrow() {
      if (!this.input) return;
      this.input.style.height = 'auto';
      this.input.style.height = `${this.input.scrollHeight}px`;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.classList.remove('is-visible');
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.classList.add('is-visible');
    }

    onInput() {
      this.clearError();
      this.syncPlaceholderVisibility();
      this.autoGrow();
      if (this.hasValue()) {
        this.stopTypewriter();
        if (this.placeholderEl) this.placeholderEl.textContent = '';
      } else {
        this.startTypewriter();
      }
    }

    onKeydown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.onSubmit();
      }
    }

    onQuickTip(event) {
      const tip = event.currentTarget?.textContent?.trim() || '';
      if (!this.input || !tip) return;

      this.input.value = tip;
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.focus();
    }

    buildTargetUrl(query) {
      const withEncodedQ = (baseHref, value) => {
        const joiner = baseHref.includes('?') ? '&' : '?';
        return `${baseHref}${joiner}q=${encodeURIComponent(value)}`;
      };

      try {
        const url = new URL(this.baseUrl, window.location.origin);
        url.searchParams.delete('q');
        const baseHref = url.toString();

        let low = 0;
        let high = query.length;
        let safeQuery = '';

        while (low <= high) {
          const mid = (low + high) >> 1;
          const candidate = query.slice(0, mid);
          if (withEncodedQ(baseHref, candidate).length <= SpxAiAssistForm.MAX_URL_LENGTH) {
            safeQuery = candidate;
            low = mid + 1;
          } else {
            high = mid - 1;
          }
        }

        if (!safeQuery) return null;

        return {
          href: withEncodedQ(baseHref, safeQuery),
          truncated: safeQuery.length < query.length,
        };
      } catch (error) {
        const joiner = this.baseUrl.includes('?') ? '&' : '?';
        const prefix = `${this.baseUrl}${joiner}q=`;
        const budget = SpxAiAssistForm.MAX_URL_LENGTH - prefix.length;
        if (budget <= 0) return null;

        let encoded = encodeURIComponent(query);
        let truncated = false;
        if (encoded.length > budget) {
          truncated = true;
          let end = query.length;
          while (end > 0 && encodeURIComponent(query.slice(0, end)).length > budget) {
            end -= 1;
          }
          if (end <= 0) return null;
          encoded = encodeURIComponent(query.slice(0, end));
        }

        return {
          href: `${prefix}${encoded}`,
          truncated,
        };
      }
    }

    onSubmit(event) {
      event?.preventDefault?.();
      this.clearError();

      const query = this.input?.value.trim() || '';
      if (!query || !this.baseUrl) return;

      const result = this.buildTargetUrl(query);
      if (!result) {
        this.showError('Your question is too long to open. Please shorten it and try again.');
        return;
      }

      if (result.truncated) {
        this.showError('Your question is too long for the link. Please shorten it and try again.');
        return;
      }

      window.open(result.href, '_blank', 'noopener,noreferrer');
    }

    startTypewriter() {
      if (!this.placeholderEl || this.hasValue()) return;
      this.stopTypewriter();

      if (this.reducedMotion || !this.placeholderText) {
        this.placeholderEl.textContent = this.placeholderText;
        return;
      }

      this.typingIndex = 0;
      this.deleting = false;
      this.placeholderEl.textContent = '';
      this.tickTypewriter();
    }

    stopTypewriter() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    tickTypewriter() {
      if (!this.placeholderEl || this.hasValue()) return;

      const full = this.placeholderText;
      if (!full) return;

      if (!this.deleting) {
        this.typingIndex += 1;
        this.placeholderEl.textContent = full.slice(0, this.typingIndex);
        if (this.typingIndex >= full.length) {
          this.deleting = true;
          this.timer = window.setTimeout(() => this.tickTypewriter(), 1600);
          return;
        }
        this.timer = window.setTimeout(() => this.tickTypewriter(), 70);
        return;
      }

      this.typingIndex -= 1;
      this.placeholderEl.textContent = full.slice(0, Math.max(this.typingIndex, 0));
      if (this.typingIndex <= 0) {
        this.deleting = false;
        this.timer = window.setTimeout(() => this.tickTypewriter(), 400);
        return;
      }
      this.timer = window.setTimeout(() => this.tickTypewriter(), 40);
    }
  }

  if (!customElements.get('spx-ai-assist-form')) {
    customElements.define('spx-ai-assist-form', SpxAiAssistForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-project-recommender"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-project-recommender')) {
    class SpxProjectRecommender extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => {
          clearTimeout(this.rebuildTimer);
          this.rebuildTimer = setTimeout(() => this.initialize(), 0);
        });
        this.observer.observe(this, { childList: true });
        this.initialize();
      }

      initialize() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.signal = this.abortController.signal;
        this.state = { step: 1, project: '', skill: '', products: new Set(), sharedProduct: '' };
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.status = this.querySelector('[data-status]');
        this.warning = this.querySelector('[data-config-warning]');
        this.addEventListener('click', (event) => this.handleClick(event), { signal: this.signal });
        this.validateConfiguration();
        this.render();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        clearTimeout(this.rebuildTimer);
      }

      normalize(value) {
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      }

      splitIds(value) {
        return String(value || '').split(',').map((key) => this.normalize(key)).filter(Boolean);
      }

      splitKeys(value) {
        return String(value || '').split(/[;,，；\s]+/).map((key) => this.normalize(key)).filter(Boolean);
      }

      selectedStep3Products() {
        if (this.state.sharedProduct) return new Set([this.state.sharedProduct]);
        return this.state.products;
      }

      handleClick(event) {
        const stepNav = event.target.closest('[data-step-indicator], [data-progress]');
        if (stepNav) {
          const target = Number(stepNav.dataset.stepIndicator || stepNav.dataset.progress);
          if (target >= 1 && target <= 3) this.goTo(target);
          return;
        }
        const choice = event.target.closest('[data-choice]');
        if (choice) {
          const option = choice.closest('[data-key], [data-step-3-product], [data-step-3-shared-option]');
          if (!option || option.hidden) return;
          const key = option.dataset.key;
          if (choice.dataset.choice === 'project') {
            this.state.project = this.state.project === key ? '' : key;
          }
          if (choice.dataset.choice === 'skill') {
            this.state.skill = this.state.skill === key ? '' : key;
          }
          if (choice.dataset.choice === 'step-3-product') {
            const productId = option.dataset.productId;
            if (!productId) return;
            if (this.state.products.has(productId)) this.state.products.delete(productId);
            else this.state.products.add(productId);
            this.state.sharedProduct = '';
          }
          if (choice.dataset.choice === 'step-3-shared-option') {
            const sharedProductId = option.dataset.sharedProductId;
            if (!sharedProductId) return;
            this.state.sharedProduct = this.state.sharedProduct === sharedProductId ? '' : sharedProductId;
            this.state.products.clear();
          }
          this.render();
          return;
        }

        if (event.target.closest('[data-next]')) this.goTo(this.state.step + 1);
        if (event.target.closest('[data-previous]')) this.goTo(this.state.step - 1);
        if (event.target.closest('[data-results]')) this.goTo(4);
        if (event.target.closest('[data-restart]')) {
          this.state = { step: 1, project: '', skill: '', products: new Set(), sharedProduct: '' };
          this.render();
        }
      }

      goTo(step) {
        if (step === 2 && !this.state.project) return;
        if (step === 3 && !this.state.skill) return;
        if (step === 4 && this.selectedStep3Products().size === 0) return;
        this.state.step = Math.max(1, Math.min(4, step));
        this.render(true);
      }

      render(moveFocus = false) {
        const { step, project, skill, products, sharedProduct } = this.state;
        const projects = Array.from(this.querySelectorAll('[data-project-option]'));
        const skills = Array.from(this.querySelectorAll('[data-skill-option]'));
        const step3Products = Array.from(this.querySelectorAll('[data-step-3-product]'));
        const sharedOptions = Array.from(this.querySelectorAll('[data-step-3-shared-option]'));

        projects.forEach((item) => item.querySelector('[data-choice]')?.setAttribute('aria-pressed', String(item.dataset.key === project)));
        skills.forEach((item) => item.querySelector('[data-choice]')?.setAttribute('aria-pressed', String(item.dataset.key === skill)));
        step3Products.forEach((item) => item.querySelector('[data-choice]')?.setAttribute('aria-pressed', String(products.has(item.dataset.productId))));
        sharedOptions.forEach((item) => item.querySelector('[data-choice]')?.setAttribute('aria-pressed', String(item.dataset.sharedProductId === sharedProduct)));

        this.panels.forEach((panel) => { panel.hidden = Number(panel.dataset.panel) !== step; });
        this.querySelectorAll('[data-step-indicator]').forEach((item) => {
          const stepActive = Number(item.dataset.stepIndicator) === Math.min(step, 3);
          item.classList.toggle('is-active', stepActive);
          if (stepActive) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');
        });
        this.querySelectorAll('[data-progress]').forEach((item) => item.classList.toggle('is-active', Number(item.dataset.progress) === Math.min(step, 3)));
        this.querySelectorAll('[data-next]').forEach((button) => { button.disabled = (step === 1 && !project) || (step === 2 && !this.state.skill); });
        this.querySelector('[data-results]')?.toggleAttribute('disabled', this.selectedStep3Products().size === 0);

        if (step === 4) this.renderResults();
        if (this.status) this.status.textContent = step === 4 ? 'Recommendations updated.' : `Step ${step} of 3.`;
        if (moveFocus) this.querySelector(`[data-panel="${step}"] [data-panel-heading]`)?.focus();
      }

      renderResults() {
        const resultCards = Array.from(this.querySelectorAll('[data-result-card]'));
        const selectedProducts = this.selectedStep3Products();
        const matches = resultCards.filter((item) => {
          if (!this.splitKeys(item.dataset.step1Id).includes(this.state.project)) return false;
          if (!this.splitKeys(item.dataset.step2Id).includes(this.state.skill)) return false;
          return this.splitIds(item.dataset.step3ProductIds).some((productId) => selectedProducts.has(productId));
        }).slice(0, 3);
        resultCards.forEach((item) => {
          const matchIndex = matches.indexOf(item);
          item.hidden = matchIndex === -1;
        });
        const empty = this.querySelector('[data-empty-results]');
        if (empty) empty.hidden = matches.length > 0;
      }

      validateConfiguration() {
        const projectKeys = new Set();
        const skillKeys = new Set();
        const step3ProductIds = new Set();
        const invalid = [];
        this.querySelectorAll('[data-project-option]').forEach((item) => {
          if (!item.dataset.key) invalid.push('step 1 ID is missing');
          else if (projectKeys.has(item.dataset.key)) invalid.push(`duplicate step 1 ID → ${item.dataset.key}`);
          else projectKeys.add(item.dataset.key);
        });
        this.querySelectorAll('[data-skill-option]').forEach((item) => {
          if (!item.dataset.key) invalid.push('step 2 ID is missing');
          else if (skillKeys.has(item.dataset.key)) invalid.push(`duplicate step 2 ID → ${item.dataset.key}`);
          else skillKeys.add(item.dataset.key);
        });
        this.querySelectorAll('[data-step-3-product]').forEach((item) => {
          if (!item.dataset.productId) invalid.push('step 3 product is missing');
          else if (step3ProductIds.has(item.dataset.productId)) invalid.push(`duplicate step 3 product → ${item.dataset.productId}`);
          else step3ProductIds.add(item.dataset.productId);
        });
        this.querySelectorAll('[data-step-3-shared-option]').forEach((item) => {
          if (!item.dataset.sharedProductId) invalid.push('shared step 3 product is missing');
          else if (!step3ProductIds.has(item.dataset.sharedProductId)) invalid.push(`shared product is not a step 3 product → ${item.dataset.sharedProductId}`);
        });
        this.querySelectorAll('[data-result-card]').forEach((item) => {
          const resultStep1Ids = this.splitKeys(item.dataset.step1Id);
          const resultStep2Ids = this.splitKeys(item.dataset.step2Id);
          if (!resultStep1Ids.length) invalid.push('result step 1 IDs are missing');
          resultStep1Ids.forEach((step1Id) => { if (!projectKeys.has(step1Id)) invalid.push(`result step 1 ID → ${step1Id}`); });
          if (!resultStep2Ids.length) invalid.push('result step 2 IDs are missing');
          resultStep2Ids.forEach((step2Id) => { if (!skillKeys.has(step2Id)) invalid.push(`result step 2 ID → ${step2Id}`); });
          const resultStep3Ids = this.splitIds(item.dataset.step3ProductIds);
          if (!resultStep3Ids.length) invalid.push('result step 3 products are missing');
          resultStep3Ids.forEach((productId) => { if (!step3ProductIds.has(productId)) invalid.push(`result step 3 product → ${productId}`); });
        });
        if (this.warning && window.Shopify?.designMode && invalid.length) {
          this.warning.hidden = false;
          this.warning.textContent = `Configuration warning: ${invalid.join(', ')}`;
        }
        if (invalid.length) console.warn('[spx-project-recommender] invalid relation keys', invalid);
      }
    }
    customElements.define('spx-project-recommender', SpxProjectRecommender);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-rf-banner"]) return;
  try {
    
  class SpxRfTypewriter extends HTMLElement {
    banner;
    input;
    observer;
    shareDialog;
    timeout;
    copyTimeout;
    hasStarted = false;

    connectedCallback() {
      this.input = this.querySelector('.spx-rf-banner__input');
      this.banner = this.closest('.spx-rf-banner');
      this.banner?.addEventListener('click', this.handleBannerClick);

      const shareDialogId = this.banner?.querySelector('[data-share-dialog-id]')?.dataset.shareDialogId;
      this.shareDialog = shareDialogId ? document.getElementById(shareDialogId) : null;
      this.shareDialog?.addEventListener('click', this.handleShareDialogClick);

      if (this.initializeAfterShare()) return;

      const text = this.input?.dataset.typewriterText;
      if (!this.input || !text) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.input.placeholder = text;
        return;
      }

      this.input.placeholder = '';

      if (!('IntersectionObserver' in window)) {
        this.start(text);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer?.disconnect();
          this.start(text);
        },
        { threshold: 0.35 }
      );
      this.observer.observe(this);
    }

    initializeAfterShare() {
      if (!this.banner) return false;

      const params = new URLSearchParams(window.location.search);
      const author = params.get('a')?.trim();
      const quote = params.get('q')?.trim();
      if (!author || !quote) return false;

      const beforeShare = this.banner.querySelector('.spx-rf-banner__before-share');
      const afterShare = this.banner.querySelector('[data-after-share]');
      if (!afterShare) return false;

      if (beforeShare) beforeShare.hidden = true;
      afterShare.hidden = false;
      this.banner.dataset.shareState = 'after';
      afterShare.querySelectorAll('[data-after-author]').forEach((element) => {
        element.textContent = author;
      });

      const quoteElement = afterShare.querySelector('[data-after-quote]');
      if (quoteElement) quoteElement.textContent = `“${quote}”`;
      return true;
    }

    disconnectedCallback() {
      this.banner?.removeEventListener('click', this.handleBannerClick);
      this.shareDialog?.removeEventListener('click', this.handleShareDialogClick);
      this.observer?.disconnect();
      window.clearTimeout(this.timeout);
      window.clearTimeout(this.copyTimeout);
    }

    handleBannerClick = (event) => {
      if (!(event.target instanceof Element)) return;

      const createButton = event.target.closest('.spx-rf-banner__create-button[data-share-dialog-id]');
      if (createButton instanceof HTMLButtonElement && this.banner?.contains(createButton)) {
        this.prepareShare(createButton);
        return;
      }

      const promotion = event.target.closest('.spx-rf-banner__promotion');
      if (!(promotion instanceof HTMLButtonElement) || !this.banner?.contains(promotion) || !this.input) return;

      const value = promotion.dataset.promotionText?.trim();
      if (!value) return;

      this.input.value = value;
      this.input.focus();
      this.input.setSelectionRange(value.length, value.length);
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    handleShareDialogClick = async (event) => {
      if (!(event.target instanceof Element) || !this.shareDialog) return;

      const url = this.shareDialog.dataset.shareUrl;
      if (!url) return;

      const copyButton = event.target.closest('[data-share-copy]');
      if (copyButton instanceof HTMLButtonElement) {
        if (await this.copy(url)) this.showCopiedState(copyButton);
        return;
      }

      const shareButton = event.target.closest('[data-share-channel]');
      if (!(shareButton instanceof HTMLButtonElement)) return;

      const channel = shareButton.dataset.shareChannel;
      const content = this.shareDialog.dataset.shareContent || '';
      const author = this.shareDialog.dataset.shareAuthor || '';

      if (channel === 'facebook') {
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
          '_blank',
          'noopener,noreferrer,width=720,height=600'
        );
        return;
      }

      if (channel === 'email') {
        const subject = author ? `A one-line moment from ${author}` : 'A one-line moment';
        const body = `${content}\n\n${url}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        return;
      }

      try {
        if (navigator.share) {
          await navigator.share({ title: 'A one-line moment', text: content, url });
        } else if (await this.copy(url)) {
          this.announceCopy();
        }
      } catch (error) {
        if (error?.name !== 'AbortError') console.error('[rf-share] Unable to share link:', error);
      }
    };

    prepareShare(trigger) {
      if (!this.input) return;

      const content = this.input.value.trim();
      const author = trigger.dataset.shareAuthor?.trim() || '';
      const shareDialogId = trigger.dataset.shareDialogId;
      const shareUrl = new URL(window.location.href);
      shareUrl.searchParams.delete('c');
      shareUrl.searchParams.set('q', content);
      shareUrl.searchParams.set('a', author);

      this.shareDialog = shareDialogId ? document.getElementById(shareDialogId) : this.shareDialog;
      if (!this.shareDialog) return;

      this.shareDialog.dataset.shareUrl = shareUrl.href;
      this.shareDialog.dataset.shareContent = content;
      this.shareDialog.dataset.shareAuthor = author;

      const linkInput = this.shareDialog.querySelector('[data-share-url]');
      const preview = this.shareDialog.querySelector('[data-share-preview]');
      if (linkInput instanceof HTMLInputElement) linkInput.value = shareUrl.href;
      if (preview) preview.textContent = `“${content}”`;
    }

    showCopiedState(button) {
      const label = button.querySelector('[data-share-copy-label]');
      window.clearTimeout(this.copyTimeout);
      if (label) label.textContent = 'Copied';
      this.announceCopy();

      this.copyTimeout = window.setTimeout(() => {
        if (label) label.textContent = 'Copy';
      }, 1500);
    }

    announceCopy() {
      const status = this.shareDialog?.querySelector('[data-share-copy-status]');
      if (status) status.textContent = 'Personal invite link copied.';
    }

    async copy(value) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.readOnly = true;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.append(textarea);
        textarea.select();

        try {
          return document.execCommand('copy');
        } catch {
          return false;
        } finally {
          textarea.remove();
        }
      }
    }

    start(text) {
      if (this.hasStarted || !this.input) return;
      this.hasStarted = true;

      const characters = Array.from(text);
      const typeCycle = () => {
        if (!this.input) return;

        let index = 0;
        this.input.placeholder = '';

        const typeNextCharacter = () => {
          if (!this.input) return;
          index += 1;
          this.input.placeholder = characters.slice(0, index).join('');

          if (index < characters.length) {
            this.timeout = window.setTimeout(typeNextCharacter, 45);
          } else {
            this.timeout = window.setTimeout(typeCycle, 1800);
          }
        };

        this.timeout = window.setTimeout(typeNextCharacter, 450);
      };

      this.timeout = window.setTimeout(typeCycle, 350);
    }
  }

  if (!customElements.get('spx-rf-typewriter')) {
    customElements.define('spx-rf-typewriter', SpxRfTypewriter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-rf-moments"] && !Shopify.designMode) return;
  try {
    
  class SpxRfMoments extends HTMLElement {
    copyTimeouts = new Map();

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.copyTimeouts.forEach((timeout) => window.clearTimeout(timeout));
      this.copyTimeouts.clear();
    }

    handleClick = async (event) => {
      const button = event.target.closest('.spx-rf-moment-card__share');
      if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;

      const shareUrl = new URL(window.location.href);
      const content = button.dataset.shareContent?.trim();
      if (content) shareUrl.searchParams.set('moment', content);

      if (!(await this.copy(shareUrl.href))) return;

      const label = button.querySelector('.spx-rf-moment-card__share-label');
      window.clearTimeout(this.copyTimeouts.get(button));
      button.dataset.copied = 'true';
      button.setAttribute('aria-label', 'Link copied');
      if (label) label.textContent = 'Copied';

      this.copyTimeouts.set(
        button,
        window.setTimeout(() => {
          delete button.dataset.copied;
          button.setAttribute('aria-label', button.dataset.defaultLabel || 'Copy link to this moment');
          if (label) label.textContent = 'Share';
          this.copyTimeouts.delete(button);
        }, 1500)
      );
    };

    async copy(value) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.readOnly = true;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.append(textarea);
        textarea.select();

        try {
          return document.execCommand('copy');
        } catch {
          return false;
        } finally {
          textarea.remove();
        }
      }
    }
  }

  if (!customElements.get('spx-rf-moments')) {
    customElements.define('spx-rf-moments', SpxRfMoments);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-swiper-video-bottom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '.spx-swiper-video-bottom';

    const setupHoverPreview = (root) => {
      if (!(root instanceof HTMLElement)) return;

      const items = root.querySelectorAll('.slide-item__image');
      items.forEach((item) => {
        if (!(item instanceof HTMLElement)) return;
        if (item.dataset.spxHoverVideoInit === 'true') return;
        item.dataset.spxHoverVideoInit = 'true';

        const video = item.querySelector('video');
        if (!(video instanceof HTMLVideoElement)) return;

        const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
        const playPreview = async () => {
          if (!canHover.matches) return;
          try {
            video.muted = true;
            video.playsInline = true;
            await video.play();
            item.setAttribute('data-video-playing', 'true');
          } catch (e) {}
        };
        const pausePreview = () => {
          try {
            video.pause();
            video.currentTime = 0;
            item.removeAttribute('data-video-playing');
          } catch (e) {}
        };

        item.addEventListener('mouseenter', playPreview);
        item.addEventListener('mouseleave', pausePreview);
        video.addEventListener('play', () => {
          item.setAttribute('data-video-playing', 'true');
        });
        video.addEventListener('pause', () => {
          item.removeAttribute('data-video-playing');
        });
      });
    };

    const init = () => {
      document.querySelectorAll(rootSelector).forEach((root) => setupHoverPreview(root));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-tab-swiper-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mountPanel = (panel) => {
      if (!(panel instanceof HTMLElement) || panel.dataset.tspMounted === 'true') return;

      const template = panel.querySelector('template[data-tsp-layout="all"]');
      const host = panel.querySelector('[data-tsp-product-host]');
      if (!(template instanceof HTMLTemplateElement) || !(host instanceof HTMLElement)) return;

      host.replaceChildren(template.content.cloneNode(true));
      host.querySelectorAll('spx-slider').forEach((slider) => {
        slider.addEventListener('click', (event) => event.stopPropagation());
      });
      panel.dataset.tspMounted = 'true';
    };

    const syncActive = (root) => {
      if (!(root instanceof HTMLElement)) return;
      const activePanel = root.querySelector('spx-panel[data-spx-tab-active]');
      if (activePanel instanceof HTMLElement) mountPanel(activePanel);
    };

    const init = (root) => {
      if (!(root instanceof HTMLElement)) return;
      if (root.dataset.tspInitialized === 'true') return;
      root.dataset.tspInitialized = 'true';

      const group = root.querySelector('[data-tsp-tab-group]');
      if (!(group instanceof HTMLElement)) return;

      const syncAfterTabInteraction = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const tab = target.closest('spx-tab[slot="nav"]');
        if (tab instanceof HTMLElement && group.contains(tab)) {
          requestAnimationFrame(() => syncActive(root));
        }
      };

      requestAnimationFrame(() => syncActive(root));
      group.addEventListener('click', syncAfterTabInteraction);
      group.addEventListener('keydown', syncAfterTabInteraction);
    };

    const initAll = () =>
      document.querySelectorAll('[data-spx-tab-swiper-products]').forEach(init);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target instanceof HTMLElement)
        e.target.querySelectorAll('[data-spx-tab-swiper-products]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-themed-design-packs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('spx-themed-design-packs')) {
    class SpxThemedDesignPacks extends HTMLElement {
      connectedCallback() {
        this._abort = new AbortController();
        this._ro = null;
        this._onResize = this._onResize.bind(this);
        this.source = this.querySelector('.spx-themed-design-packs__source');
        this.slider = this.querySelector('spx-slider');
        this.wrapper = this.slider ? this.slider.querySelector('.swiper-wrapper') : null;
        if (!this.source || !this.slider || !this.wrapper) return;
        this.albums = Array.from(this.source.children);
        this._build();
        window.addEventListener('resize', this._onResize, { signal: this._abort.signal });
        this._ro = new ResizeObserver(() => this._rebuildIfNeeded());
        this._ro.observe(this);
        this._lastKey = this._key();
      }

      disconnectedCallback() {
        this._abort.abort();
        if (this._ro) this._ro.disconnect();
      }

      _key() {
        const w = window.innerWidth;
        if (w >= 1024) return 'desktop';
        if (w >= 750) return 'tablet';
        return 'mobile';
      }

      _config() {
        const w = window.innerWidth;
        if (w >= 1024) return { top: 4, bottom: 5, perPage: 9 };
        if (w >= 750) return { top: 3, bottom: 4, perPage: 7 };
        return { top: 2, bottom: 2, perPage: 4 };
      }

      _onResize() {
        clearTimeout(this._t);
        this._t = setTimeout(() => this._rebuildIfNeeded(), 120);
      }

      _rebuildIfNeeded() {
        const k = this._key();
        if (k !== this._lastKey) {
          this._lastKey = k;
          this._build();
        }
      }

      _build() {
        if (!this.wrapper || !this.slider) return;
        const cfg = this._config();
        const slider = this.slider;
        const hadSwiper = !!slider.swiperInstance;
        if (hadSwiper && typeof slider.destroySwiper === 'function') slider.destroySwiper();
        this.wrapper.innerHTML = '';
        const pools = this.albums.slice();
        if (pools.length === 0) {
          const empty = document.createElement('div');
          empty.className = 'swiper-slide';
          empty.innerHTML =
            '<div class="spx-themed-design-packs__page"><p class="text-center text-sm" style="color:var(--color-text-secondary)">Add albums in the theme editor.</p></div>';
          this.wrapper.appendChild(empty);
        } else {
          let idx = 0;
          while (idx < pools.length) {
            const pageAlbums = pools.slice(idx, idx + cfg.perPage);
            const topAlbums = pageAlbums.slice(0, cfg.top);
            const bottomAlbums = pageAlbums.slice(cfg.top);
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            const page = document.createElement('div');
            page.className = 'spx-themed-design-packs__page';
            const topRow = document.createElement('div');
            topRow.className = 'spx-themed-design-packs__row spx-themed-design-packs__row--top';
            const bottomRow = document.createElement('div');
            bottomRow.className = 'spx-themed-design-packs__row spx-themed-design-packs__row--bottom';
            topAlbums.forEach((el) => topRow.appendChild(el));
            bottomAlbums.forEach((el) => bottomRow.appendChild(el));
            if (topAlbums.length) page.appendChild(topRow);
            if (bottomAlbums.length) page.appendChild(bottomRow);
            slide.appendChild(page);
            this.wrapper.appendChild(slide);
            idx += cfg.perPage;
          }
        }
        if (typeof slider.syncSwiperWithViewport === 'function') {
          requestAnimationFrame(() => slider.syncSwiperWithViewport());
        } else if (typeof slider.initSwiper === 'function') {
          requestAnimationFrame(() => slider.initSwiper());
        }
      }
    }
    customElements.define('spx-themed-design-packs', SpxThemedDesignPacks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spx-tiered-discount-grid"] && !Shopify.designMode) return;
  try {
    
  class SpxTieredDiscountGrid extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.copyTimeouts = new WeakMap();
      this.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    handleClick = async (event) => {
      const card = event.target.closest('.spx-tiered-discount-grid__card');
      if (!(card instanceof HTMLButtonElement) || !this.contains(card)) return;

      const discountCode = card.dataset.discountCode;
      if (!discountCode || !(await this.copy(discountCode))) return;

      window.clearTimeout(this.copyTimeouts.get(card));
      card.dataset.copied = 'true';
      this.querySelector('[ref="status"]')?.replaceChildren(document.createTextNode('Discount code copied.'));

      this.copyTimeouts.set(
        card,
        window.setTimeout(() => {
          delete card.dataset.copied;
        }, 1500),
      );
    };

    async copy(value) {
      try {
        await navigator.clipboard.writeText(value);
        return true;
      } catch {
        const textarea = document.createElement('textarea');
        textarea.value = value;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.append(textarea);
        textarea.select();
        const copied = document.execCommand('copy');
        textarea.remove();
        return copied;
      }
    }
  }

  if (!customElements.get('spx-tiered-discount-grid')) {
    customElements.define('spx-tiered-discount-grid', SpxTieredDiscountGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
